import clsx from 'clsx';
import { Button, CircularProgress, Typography, makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';

const mainConfig = {
	position: 'top-center',
	hideProgressBar: true,
	closeButton: false,
	closeOnClick: true,
	// draggable: true,
	pauseOnHover: true,
	pauseOnFocusLoss: true,
	pause: true,
};

const useStyles = makeStyles(() => ({
	button: {
		borderRadius: 12,
		height: 50,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		boxShadow: 'none',
		width: '100%',
		'&:hover': {
			boxShadow: 'none',
		},
		'&:focus': {
			boxShadow: 'none',
		},
		'&:active': {
			boxShadow: 'none',
		},
	},

	shadowDisabled: {
		backgroundColor: '#DBDBDB',
		height: 50,
		width: '100%',
		color: '#FFFFFF',
		'&:hover': {
			backgroundColor: '#DBDBDB',
			boxShadow: 'none',
		},
	},
	spinner: {
		margin: '10px 0 0 10px',
	},
	errorToast: {
		backgroundColor: '#EE3863 !important',
		width: '100% !important',
		padding: '12px 20px',
		display: 'flex !important',
		justifyContent: 'center !important',
		alignItems: 'center !important',
		textAlign: 'left !important',
	},
}));

const MuiButton = (props) => {
	const { children, message, shadowDisabled, loadingSize, isLoading, ...rest } = props;
	const classes = useStyles();

	const showErrorMessage = () => {
		message &&
			toast.error(message, {
				...mainConfig,
				className: classes.errorToast,
				autoClose: 1000,
				icon: (
					<i style={{ color: '#fff !important', fontSize: 18, marginTop: '-5px' }} className="icon-error" />
				),
			});
	};

	return (
		<div style={{ width: '100%' }}>
			<Button
				className={clsx(classes.button, {
					[classes.shadowDisabled]: shadowDisabled,
				})}
				disabled={isLoading || rest.disabled}
				{...(isLoading && {
					endIcon: (
						<div className={classes.spinner}>
							<CircularProgress
								color="primary"
								size={loadingSize === 'small' ? 20 : loadingSize === 'medium' ? 25 : 30}
							/>
						</div>
					),
				})}
				{...rest}
				{...(shadowDisabled && { onClick: showErrorMessage })}
			>
				<Typography style={{ fontWeight: 'bold' }}>{children}</Typography>
			</Button>
		</div>
	);
};

MuiButton.defaultProps = {
	disableRipple: true,
	type: 'button', //reset,submit
	color: 'primary', //default,inherit,secondary,warning
	variant: 'contained', //outlined,text
	fullWidth: true, // force full width if value is true
	isLoading: false,
	loadingSize: 'small', // medium,large
	shadowDisabled: false,
	message: '', //متن دلخواه خودتون مربوط به خطای خودتون تو مسیج بنویسید و حتما یادتون حالت غیرفعال سایه ایی رو فعال کنید
};

export default MuiButton;
